import { UserContext } from '@providers/userContextProvider';
import { withActiveOrganizationId } from '@utils/activeOrganization';
import { Button } from 'hephaestus/web';
import { useContext } from 'react';
import { useTranslation } from 'react-i18next';

export type BulkRebalanceOpenPortfolioButtonProps = {
  pagePath: string;
};

export const BulkRebalanceOpenPortfolioButton = ({
  pagePath,
}: BulkRebalanceOpenPortfolioButtonProps) => {
  const { t } = useTranslation(['bulkRebalance']);
  const { activeOrganization } = useContext(UserContext);

  return (
    <Button
      variant='outlined'
      size='small'
      href={withActiveOrganizationId(pagePath, activeOrganization.id)}
      target='_blank'
      data-testid='bulk-rebalance-review-portfolio-open'
    >
      {t('drawer.reviewPortfolioOpen')}
    </Button>
  );
};
